/**
 * Created by Danila Krupnov on 6/8/25
 */

const BackgroundsItem = cc.Node.extend({
    ctor: function (options) {
        this._super();
        this.options = options || {};

        this.spine = this.createSpine();
        this.addChild(this.spine);
        this.showUpAnimation();

        let size = this.spine.getContentSize();
        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            size = { width: size.width * this.options.baseScale, height: size.height * this.options.scale + cleverapps.styles.BackgroundsItem.margin };
        }
        this.setContentSize2(size.width, size.height);
    },

    createSpine: function () {
        const spine = new cleverapps.Spine(bundles.simple.jsons.item_json);
        const stage = cleverapps.meta.getSelectedLocation().getStage() - (this.options.moveNext ? 1 : 0);

        if (cleverapps.config.ui === "playrix") {
            this.addBackgroundImage(spine);
            this.addTitle(spine);
            if (cleverapps.meta.getSelectedLocation().getStage() + 1 === this.options.locationId) {
                this.addNextText(spine);
            }
        }

        if (cleverapps.config.ui === "empire") {
            if (stage >= this.options.locationId || this.options.comingSoon) {
                this.addTitle(spine);
                this.addStickers(spine);
            }
            if (!(this.options.moveNext && cleverapps.meta.getSelectedLocation().getStage() === this.options.locationId)) {
                this.addText(spine);
            }
        }

        if (cleverapps.config.ui === "simple") {
            this.addBackgroundImage(spine);
            this.addTitle(spine);
        }
        if (stage <= this.options.locationId && cleverapps.config.ui !== "simple" && spine.hasSlot("slot_location")) {
            this.addLocationNumber(spine);
        }

        if (!this.options.moveNext && cleverapps.meta.getSelectedLocation().getStage() === this.options.locationId) {
            this.addProgressBar(spine);
        }

        this.options.scale && spine.setScale(this.options.scale);
        spine.setAlignment({ x: { align: "center" }, y: { align: "center" } });

        let animation = this.options.comingSoon ? "idle_close_without_lock" : "idle_open";
        if (stage > this.options.locationId) {
            animation = "idle_complete";
        } else if (stage < this.options.locationId) {
            animation = "idle_close";
        } else if (this.options.comingSoon && spine.hasAnimation("idle_soon")) {
            animation = "idle_soon";
        }
        spine.hasAnimation(animation) && spine.setAnimation(0, animation, true);

        return spine;
    },

    getParticleSpine: function () {
        const particleSpine = new cleverapps.Spine(bundles.simple.jsons.item_json);
        particleSpine.setAlignment({ x: { align: "center" }, y: { align: "center" } });
        particleSpine.setLocalZOrder(-1);
        particleSpine.setCompleteListenerRemove();
        particleSpine.setScale(this.spine.getScale());
        this.addChild(particleSpine);

        return particleSpine;
    },

    showUpAnimation: function () {
        const baseScale = this.options.baseScale;
        const scale = this.options.scale;
        const locationId = this.options.moveNext ? this.options.locationId + 1 : this.options.locationId;
        const targetScale = cleverapps.meta.getSelectedLocation().getStage() === locationId ? baseScale : scale;

        this.spine.setScale(targetScale * 0.5);
        this.spine.runAction(new cc.ScaleTo(0.4, targetScale).easing(cc.easeBackOut()));
    },

    hideAnimation: function () {
        this.spine.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, this.spine.scale * 0.2).easing(cc.easeIn(2)),
            new cc.Hide()
        ));
    },

    fillProgressBar: function (next) {
        this.addProgressBar(this.spine);
        this.progressBar.setStars(SimpleLocation.GetRequiredProgress(this.options.locationId) - 1);

        const progressBarAnimation = new cleverapps.Spine(bundles.progress_bar.jsons.flash_json);
        this.progressBar.bar.addChild(progressBarAnimation);
        progressBarAnimation.setVisible(false);
        progressBarAnimation.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            new cc.CallFunc(() => {
                progressBarAnimation.setVisible(true);
                progressBarAnimation.setAlignment(progressBarAnimation.width / 2, this.progressBar.bar.height / 2);
                progressBarAnimation.setAnimation(0, "animation");
            }),
            new cc.MoveTo(0.4, this.progressBar.bar.width, this.progressBar.bar.height / 2),
            new cc.CallFunc(() => {
                progressBarAnimation.setVisible(false);
            })
        ));

        this.progressBar.animateToFull(next);
    },

    hidePresentAndFlyRewards: function (next) {
        if (this.stopListeners) {
            const rewards = cleverapps.meta.getSelectedLocation().calcReward(true, this.options.locationId);
            rewards.forEach((rewardItem) => {
                new Reward(rewardItem.type, rewardItem.value, { event: cleverapps.EVENTS.EARN.SIMPLE_REWARD }).receiveReward();
            });
            if (next) {
                next();
            }
            return;
        }

        const present = this.progressBar.present;

        let source = present;
        if (present) {
            source = new cc.Node();
            this.addChild(source);
            source.setPosition(this.convertToNodeSpace(present.parent.convertToWorldSpace(present.getPosition())));
        }

        cleverapps.effects.fire("reward.collect");
        this.progressBar.runAction(new cc.ScaleTo(0.3, 0).easing(cc.easeIn(2)));
        this.progressBar.receivePrize(next, source);
    },

    playComplete: function () {
        if (this.spine.stopListeners) {
            return;
        }
        this.spine.setAnimation(0, "idle_open", true);
        this.spine.runAction(new cc.Sequence(
            new cc.CallFunc(() => this.getParticleSpine().setAnimation(0, "particle", false)),
            cleverapps.effects.fireAction("location.simple.newlocation"),
            new cc.DelayTime(0.2),
            new cc.CallFunc(() => {
                this.locationNumber && this.locationNumber.setVisible(false);
                this.spine.setAnimation(0, "complete", false);
            })
        ));
    },

    openLock: function (next) {
        if (this.spine.stopListeners) {
            if (next) {
                next();
            }
            return;
        }
        this.spine.setAnimation(0, "idle_close", true);
        this.spine.runAction(new cc.Sequence(
            cleverapps.effects.fireAction("location.simple.unlock"),
            new cc.CallFunc(() => this.showProgressBarAnimated()),
            new cc.SpineAction(this.spine, "open"),
            new cc.DelayTime(0.2),
            new cc.CallFunc(next || (() => { }))
        )).setFinalize(next || (() => { }));
    },

    showProgressBarAnimated: function () {
        this.addProgressBar(this.spine);
        this.progressBar.setScale(0);
        this.progressBar.runAction(new cc.ScaleTo(0.3, 1).easing(cc.easeBackOut(2)));
    },

    addTitle: function (spine) {
        const titleSlot = spine.getSlot("slot_title");
        const msg = this.options.comingSoon ? "Simple.ComingSoon" : "background_name_" + this.options.locationId;
        const title = this.title = cleverapps.UI.generateOnlyText(Messages.get(msg), cleverapps.styles.FONTS.BACKGROUNDS_WINDOW_NAME_TITLE_TEXT);
        titleSlot.setLocalZOrder(10);
        titleSlot.addChild(title);
        title.fitTo(titleSlot.width, 0);
        title.setAlignment({ align: "center" }, { align: "center" });
    },

    addStickers: function (spine) {
        this.stickers = [];

        if (this.options.comingSoon) {
            const slotName = cleverapps.config.name === "jigsolitaire" ? "slot_sticker_1" : "slot_sticker_2"; // temp

            const stickerSlot = spine.getSlot(slotName);
            const stickerBg = new cc.Sprite(bundles.simple.frames["sticker_coming_soon"]);
            stickerSlot.setLocalZOrder(15);
            stickerSlot.addChild(stickerBg);
            stickerBg.setAlignment({ align: "center" }, { align: "center" });
            this.stickers.push(stickerBg);
            return;
        }

        for (let i = 0; i < 3; i++) {
            const stickerSlot = spine.getSlot("slot_sticker_" + (i + 1));
            const stickerBg = new cc.Sprite(bundles.simple_stickers.frames["sticker_" + this.options.locationId + "_" + i]);
            stickerSlot.setLocalZOrder(15);
            stickerSlot.addChild(stickerBg);
            stickerBg.setAlignment({ align: "center" }, { align: "center" });
            this.stickers.push(stickerBg);
        }
    },

    addLocationNumber: function (spine) {
        const style = cleverapps.styles.BackgroundsItem;

        const locationNumberSlot = spine.getSlot("slot_location");
        let font = cleverapps.styles.FONTS.BACKGROUNDS_WINDOW_NUMBER_TEXT;
        if (cleverapps.config.ui === "playrix") {
            font = cleverapps.meta.getSelectedLocation().getStage() === this.options.locationId
                ? cleverapps.styles.FONTS.BACKGROUNDS_WINDOW_NUMBER_TEXT
                : cleverapps.styles.FONTS.BACKGROUNDS_WINDOW_NUMBER_TEXT_BROWN;
        }
        const text = this.locationNumber = cleverapps.UI.generateOnlyText(this.options.locationId + 1, font);
        locationNumberSlot.addChild(text);
        text.setAlignment(style.location_number);
    },

    addBackgroundImage: function (spine) {
        const bgSlot = spine.getSlot("slot_bg");
        const bg = this.background = new cleverapps.UI.ThumbnailedSprite(bundles.backgrounds_window.urls[`background_${this.options.locationId}`], { deferred: true });
        bg.setAlignment(bgSlot.getPosition());
        spine.addChild(bg, -1);
    },

    loadBackground: function () {
        if (this.background) {
            this.background.load();
        }
    },

    addNextText: function (spine) {
        const titleSlot = spine.getSlot("slot_progress");
        const text = cleverapps.UI.generateOnlyText(Messages.get(this.options.comingSoon ? "Simple.ComingSoonText" : "Simple.Next"), cleverapps.styles.FONTS.BACKGROUNDS_WINDOW_NEXT_TEXT);
        titleSlot.addChild(text);
        text.setDimensions(titleSlot.width, 0);
        text.setAlignment({ align: "center" }, { align: "center" });
    },

    addProgressBar: function (spine) {
        const progressBaseSlot = spine.getSlot("slot_progress");
        const location = cleverapps.meta.getSelectedLocation();

        const progressBar = this.progressBar = new StarsProgressBar({
            width: progressBaseSlot.width,
            current: this.options.locationId,
            withPresent: !location.isLastStage(location.getStage())
        });

        progressBaseSlot.addChild(progressBar);
        progressBar.setAlignment({ align: "center" }, { align: "center" });
    },

    addText: function (spine) {
        const progressTextSlot = spine.getSlot("slot_text");
        const currentOrCompleted = cleverapps.meta.getSelectedLocation().getStage() >= this.options.locationId;
        let msg = currentOrCompleted ? "simple_text_" + this.options.locationId : "simple_text_next";
        if (this.options.comingSoon) {
            msg = "simple_text_coming_soon";
        }
        const font = currentOrCompleted
            ? cleverapps.styles.FONTS.BACKGROUNDS_WINDOW_OPENED_CARD_TEXT
            : cleverapps.styles.FONTS.BACKGROUNDS_WINDOW_CLOSED_CARD_TEXT;
        const text = this.text = cleverapps.UI.generateOnlyText(Messages.get(msg), font);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(progressTextSlot.width, 0);
        text.setAlignment({ align: "center" }, { align: "center" });
        progressTextSlot.addChild(text);
    }
});

cleverapps.styles.BackgroundsItem = {
    margin: 80,
    location_number: {
        x: { align: "center" },
        y: { align: "center" }
    }
};
